import { ActivityView } from "../ActivityView/ActivityView";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { Content, InstallPWABtn } from "./styles";
import { useInstallPWA } from "./hooks";
import { isAndroid, isIOS } from "react-device-detect";
import ShareIcon from "./IconShare";
import { useTranslation } from "react-i18next";

export default function InstallationBanner({
  visible,
  setVisible,
}: {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
}) {
  const { isInstalled, installPWA, deferredPrompt } = useInstallPWA();
  const lastTimeVisible = localStorage.getItem("PWABannerLastVisibleTime");
  const {t} = useTranslation();

  useEffect(() => {
    if (
      isAndroid &&
      isInLegitimateTimeFrame() &&
      !isInstalled &&
      !!deferredPrompt
    ) {
      setVisible(true);
    }
    if (isIOS && isInLegitimateTimeFrame() && !isInstalled) {
      setVisible(true);
    }
    if (isInstalled) {
      setVisible(false);
    }
  }, [isInstalled, deferredPrompt]);

  function isInLegitimateTimeFrame() {
    return (
      !lastTimeVisible ||
      (!!lastTimeVisible &&
        new Date().getTime() - Number(lastTimeVisible) > 10 * 86400000) // 10 days passed from last reminder
    );
  }

  function onRemindMeLater() {
    localStorage.setItem(
      "PWABannerLastVisibleTime",
      new Date().getTime().toString()
    );
    setVisible(false);
  }

  function androidContent() {
    return (
      <Content>
        <span>{t("mobile.contentSpan.title")}</span>
        <InstallPWABtn
          id="pwa-installation-banner-install-btn"
          customStyle="flex-direction: row"
          width="100%"
          color={"btnColor"}
          backgroundColor={"bgPrimary"}
          onClick={() => installPWA()}
          primary={true}
          text={t("mobile.contentSpan.btn")}
        />
        <InstallPWABtn
          id="pwa-installation-banner-close-btn"
          customStyle="flex-direction: row-reverse"
          className={"mt-3"}
          width="100%"
          color={"btnColor"}
          backgroundColor={"bgRed"}
          onClick={onRemindMeLater}
          primary={true}
          text={t("mobile.contentSpan.btnLater")}
        />
      </Content>
    );
  }

  function iosContent() {
    return (
      <Content>
        <span>
        {t("mobile.contentSpan.descP1")}
          <span className={"mx-2"}>
            <ShareIcon />
          </span>
          {t("mobile.contentSpan.descP2")}
        </span>
        <InstallPWABtn
          id="pwa-installation-banner-close-btn"
          customStyle="flex-direction: row-reverse"
          width="100%"
          color={"btnColor"}
          backgroundColor={"bgRed"}
          onClick={onRemindMeLater}
          primary={true}
          text={t("mobile.contentSpan.btnClose")}
        />
      </Content>
    );
  }

  return (
    <ActivityView
      onClose={() => setVisible(false)}
      dim={"confirm"}
      roundedTop={false}
      show={visible}
      customId={"pwa-installation-banner"}
      maxHeight={isIOS ? "200px" : "380px"}
    >
      {isAndroid && androidContent()}
      {isIOS && iosContent()}
    </ActivityView>
  );
}
